import { SuccessFeeType } from './ProductSubscription';

export interface Product {
	productGuid: string;
	productName: string;
	productCategory: ProductCategory;
	subscriptionPrice: number;
	setupFee: number;
	term: number;
	basisPoints: number | null;
	reducedFeeLenderDiscountPercent: number | null;
	unitsPurchased: number;
	productStatus: number;
	cancellationFee: number | null;
	unitPrice: number;
	implementationPrice: number;
	successFeeType: SuccessFeeType;
	accessFeePaymentScheduleType: number;
	cancellationFeePaymentScheduleType: number;
	subscriptionFrequency: SubscriptionFrequency;
	isContractRequired: boolean | null;
	isCompanySubscriptionDealProduct: boolean;
	isDirectIntroProduct: boolean;
	minimumSuccessFee: number | null;
	successFeePaymentScheduleType: number;
	successFeeTiers: SuccessFeeTier[];
}

export type ProductCategory = keyof typeof ProductCategoryMap;
export const ProductCategoryMap = {
	Explorer: 'Credit Explorer',
	Navigator: 'Compliance Navigator',
};

export type SubscriptionFrequency = keyof typeof SubscriptionFrequencyMap;
export const SubscriptionFrequencyMap = {
	OneTime: 'One-Time',
	Annually: 'Annually',
	BiAnnually: 'Bi-Annual',
	Quarterly: 'Quarterly',
	Monthly: 'Monthly',
};

export interface SuccessFeeTier {
	guid: string;
	basisPoints: number;
	lowerFundingAmount: number;
	upperFundingAmount: number | null;
	isDefault: boolean;
}
